import React, { Component } from "react";
import { toJS } from "mobx";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import { GridRow, GridColumn, Img } from "arv-reactcomponents";
import FavoriteProduct from "../FavoriteProduct";

import { isApp, getBaseRouteForPath } from "../../../utils";

@inject("WishListStore")
@observer
class FavoriteProducts extends Component {
  constructor() {
    super();
  }

  render() {
    const { favoritesData } = this.props.WishListStore;
    return (
      <div className="nw-favoriteproducts">
        <div className="nw-favoriteproducts-container">
          <GridRow className="nw-favoriteproducts-list">
            {favoritesData.map(product => (
              <FavoriteProduct.component
                key={product.styleId}
                product={product}
              />
            ))}
          </GridRow>
        </div>
      </div>
    );
  }
}

FavoriteProducts.wrappedComponent.propTypes = {
  WishListStore: PropTypes.shape({
    favoritesData: PropTypes.arrayOf(PropTypes.shape({})).isRequired, // eslint-disable-line
  }).isRequired,
};

const getFinalComponent = component =>
  inject("WishListStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: FavoriteProducts.wrappedComponent,
  component: FavoriteProducts,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/Favorites/FavoriteProducts/index.js